<app-modal-header
    [modalTitle]="modalTitle"
    [showCloseBtn]="false"
></app-modal-header>
<!-- Modal Content -->
<div
    class="modal-content h-100 w-100"
    [attr.loading]="loading"
    [attr.size]="'large'"
    [attr.flexDirection]="'row'"
>
    <section *ngIf="!loading" class="primary-section-container h-100 w-100">
        <p-chart
            class="chart h-100"
            id="output-detail-chart"
            type="line"
            [data]="config.data.data"
            [options]="config.data.options"
        ></p-chart>
    </section>
    <!-- Loading Component -->
    <app-loader *ngIf="loading" [loadingMessage]="loadingMessage"></app-loader>
</div>
<!-- Modal Footer -->
<app-modal-footer
    (closeModal)="close()"
    [closeBtnText]="'Close'"
    [showUpdateBtn]="false"
></app-modal-footer>
